/* eslint-disable react/jsx-props-no-spreading */
import { string } from "prop-types";
import { Routes, Route, Navigate } from "react-router-dom";

import { MainContainer } from "../UI/Containers";
import { tdpDetails } from "../../shared/HOCs/withRedux";
import { USERTYPE } from "../../shared/reduxRoutes/tdpDetailsRoutes";
import { isAgent } from "../shared/helpers";

import NaviLinks from "./Navigation";
import Timeline from "./Timeline";
import Tasks from "./Tasks";
import Notes from "./Notes";
import Details from "./Details";
import Marketing from "./Marketing";
import Feedback from "./Feedback";
import Docs from "./Docs";
import Financials from "./Financials";

const Main = ({ userType }) => (
  <MainContainer>
    <NaviLinks />
    <Routes>
      <Route path="timeline" element={<Timeline />} />
      <Route path="tasks" element={<Tasks />} />
      <Route path="notes" element={<Notes />} />
      <Route path="details" element={<Details />} />
      <Route path="marketing" element={<Marketing />} />
      <Route path="feedback" element={<Feedback />} />
      <Route path="docs" element={<Docs />} />
      <Route
        path="financials"
        element={isAgent(userType) ? <Navigate to={`/tasks${location.search}`} /> : <Financials />}
      />
      <Route path="*" element={<Navigate to={`/tasks${location.search}`} />} />
    </Routes>
  </MainContainer>
);

export default tdpDetails({
  WrappedComponent: Main,
  states: USERTYPE,
});

Main.propTypes = {
  userType: string.isRequired,
};
